import { useContext, useEffect, useState } from "react";
import {
  Button as ChakraButton,
  Flex,
  Text,
  useDisclosure,
  useToast,
} from "@chakra-ui/react";
import { FaCopy } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
// import { text } from "stream/consumers";
import { DateTime } from "luxon";
import { MdOutlineDeleteForever } from "react-icons/md";
import { DeletePaymentLinkModal } from "../Modals/DeletePaymentLinkModal";
import { EmployeeLeavesRemarkModal } from "../Modals/EmployeeLeavesRemarkModal";
import { hasPermission } from "../../utils/authUtils";
import {
  formatHrmsDateRange,
  LeaveTypeBadge,
  StatusBadge,
} from "../Hrms/hrmsUi";

export const SingleRowEmployeeLeave = ({ id, data, func }: any) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [modal, setModal] = useState("");
  const canApproveLeaves =
    hasPermission("leave.approve.level1") || hasPermission("leave.approve.level2");
  const toast = useToast();

  const levelNote =
    data?.status === "pending" && data?.approvals?.length > 0
      ? `Level ${data.currentLevel} of ${data.requiredLevels} · ${
          data.approvals.find((a: any) => a.level === data.currentLevel)
            ?.approverEmail || "-"
        }`
      : "";

  // Notes approvers left in the Review Leave popup, shown to the applicant.
  const approverNotes = (data?.approvals || []).filter(
    (a: any) => a.note && a.status !== "pending"
  );

  return (
    <tr>
      <td>
        <LeaveTypeBadge type={data?.type} />
      </td>
      <td style={{ whiteSpace: "nowrap" }}>
        <Text fontSize="13px" fontWeight="500" m={0}>
          {formatHrmsDateRange(data?.start_date, data?.end_date)}
        </Text>
        <Text fontSize="11px" color="gray.500" m={0}>
          {data?.duration === "half" ? "Half day" : "Full day"}
        </Text>
      </td>
      <td>
        <Text fontSize="13px" m={0} noOfLines={2} maxW="320px" color={data?.reason ? undefined : "gray.400"}>
          {data?.reason || "-"}
        </Text>
      </td>
      <td>
        <StatusBadge status={data?.status} />
        {levelNote && (
          <Text fontSize="11px" color="gray.500" m={0} mt={1} noOfLines={1}>
            {levelNote}
          </Text>
        )}
        {approverNotes.map((a: any) => (
          <Text key={a.level} fontSize="11px" color="gray.600" m={0} mt={1} maxW="260px">
            <Text as="span" fontWeight="600">
              {approverNotes.length > 1 ? `L${a.level} ` : ""}
              {a.approverEmail}:
            </Text>{" "}
            {a.note}
          </Text>
        ))}
      </td>

      {canApproveLeaves ? (
        <td>
          <Flex align="center" gap={2}>
            {data?.note && (
              <Text fontSize="12px" color="gray.600" m={0} noOfLines={1} maxW="180px">
                {data.note}
              </Text>
            )}
            <ChakraButton
              size="xs"
              variant="outline"
              onClick={() => {
                setModal("notemodal");
                onOpen();
              }}
            >
              {data?.note ? "Edit" : "Add remark"}
            </ChakraButton>
          </Flex>
        </td>
      ) : (
        <td>
          <Text fontSize="12px" color={data?.note ? "gray.600" : "gray.400"} m={0}>
            {data?.note || "-"}
          </Text>
        </td>
      )}

      {modal === "notemodal" && (
        <EmployeeLeavesRemarkModal
          existingNote={data?.note}
          isOpen={isOpen}
          onClose={onClose}
          func={func}
          id={id}
        />
      )}
      {/* <td>
        <div className="d-flex align-items-center">
          <span title="Delete">
            <MdOutlineDeleteForever
              className="deleteButton pointer"
              onClick={() => {
                setModal("deletemodal");
                onOpen();
              }}
            />
          </span>
        </div>
      </td>
      {modal === "deletemodal" && (
        <DeletePaymentLinkModal
          isOpen={isOpen}
          onClose={onClose}
          func={func}
          id={data.id}
          price={data.amount / 100}
        />
      )} */}
    </tr>
  );
};
